import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import InputLabel from "@mui/material/InputLabel";
import {MyTextInput} from "../../MyTextInput";
import {ErrorMessage} from "formik";
import Select from "react-select";
import {ListItemText} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {makeStyles} from "@mui/styles";
import {MyCheckbox} from "../../MyCheckbox";
import ComponentTypeAutoComplete from "../../../shared/ComponentTypeAutoComplete";
import DataobjectService from "../../../services/DataobjectService";


import ParentObjectEditComponent from "../../../shared/ParentObjectEditComponent";

const useStyles = makeStyles((theme) => ({
    itemText: {
        margin: "10px",
        paddingLeft: "30px",
    },
    ListComp: {
        padding: "30px",
        margin: "10px",
    },
    InputLabel: {
        width: "200px"
    },
    selectbox: {
        width: "100%"
    },
}));

function DataObjectFormItems({dataObjectSelected, options, attributeList, instanceTypeId, onChangeInstanceType, realestateobjectParentValue, setRealestateobjectParentValue, administrativeobjectParentValue, setAdministrativeobjectParentValue, useTypeOptions, useTypeId, onChangeUseType}) {
    const classes = useStyles();
    const token = useSelector((state) => state.keycloakToken);
    const realm = useSelector((state) => state.theRealm);

    const [liegenschaftSubFlatList, setLiegenschaftSubFlatList] = useState([]);
    const [weSubFlatList, setWeSubFlatList] = useState([]);

    function convert3(item) {
        return {
            name: item.name,
            id: item.id,
            guid: item.guid,
            title: item.name,
            key: item.guid,
        };
    }

    function convertWe(item) {
        return {
            name: item.name,
            id: item.id,
            guid: item.guid,
            title: item.name,
            key: item.guid,
        };
    }

    const getRealestateobjectParents = async (guid) => {
        const objs = await DataobjectService.listrealestateobjectparents(token, realm, guid);
        return objs?.data;
    }

    const getAdministrativeobjectParents = async (guid) => {
        const objs = await DataobjectService.listadministrativeobjectparents(token, realm, guid);
        return objs?.data;
    }

    const setRealestateobjectsValues = async (guid) => {
        if (guid) {
            const objs = await DataobjectService.listrealestateobjectchildren(token, realm, guid);
            if (objs?.data && objs.data instanceof Array) {
                setLiegenschaftSubFlatList(objs.data.map(convert3));
            }
        }
    }

    const setAdministrativeobjectsValues = async (guid) => {
        if (guid) {
            const objs = await DataobjectService.listadministrativeobjectchildren(token, realm, guid);
            if (objs?.data && objs.data instanceof Array) {
                setWeSubFlatList(objs.data.map(convertWe));
            }
        }
    }

    useEffect(() => {
        async function loadParentData() {
            if (dataObjectSelected.realestateobjectType && dataObjectSelected.guid) {
                const result = await getRealestateobjectParents(dataObjectSelected.guid);
                if (result && result instanceof Array && result.length > 0) {
                    await setRealestateobjectsValues(result[0].guid);
                }
            } else if (dataObjectSelected.administrativeobjectType && dataObjectSelected.guid) {
                const result = await getAdministrativeobjectParents(dataObjectSelected.guid);
                if (result && result instanceof Array && result.length > 0) {
                    await setAdministrativeobjectsValues(result[0].guid);
                }
            }
        }
        loadParentData();
    }, []);

    return (
        <List>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Bezeichnung</InputLabel>
                <MyTextInput
                    autoFocus
                    margin="dense"
                    name="name"
                    type="text"
                    fullWidth
                    required
                />
                <ErrorMessage name="name"/>
            </ListItem>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Typ</InputLabel>
                <ListItemText>{dataObjectSelected.realestateobjectType ? dataObjectSelected.realestateobjectType : dataObjectSelected.administrativeobjectType}</ListItemText>
            </ListItem>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Guid</InputLabel>
                <MyTextInput
                    disabled
                    margin="dense"
                    name="guid"
                    type="text"
                    fullWidth
                />
            </ListItem>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Beschreibung</InputLabel>
                <MyTextInput
                    margin="dense"
                    name="description"
                    type="text"
                    fullWidth
                />
            </ListItem>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Nummer</InputLabel>
                <MyTextInput
                    margin="dense"
                    name="number"
                    type="text"
                    fullWidth
                />
            </ListItem>
            <ListItem>
                <InputLabel className={classes.InputLabel}>Kennzeichen</InputLabel>
                <MyTextInput
                    margin="dense"
                    name="label"
                    type="text"
                    fullWidth
                />
            </ListItem>
            {dataObjectSelected.realestateobjectType ? (
                <ParentObjectEditComponent
                    name={dataObjectSelected.parentRealestateobjectName}
                    guid={dataObjectSelected.parentRealestateobjectGuid}
                    flatList={liegenschaftSubFlatList}
                    setValue={setRealestateobjectParentValue}
                    value={realestateobjectParentValue}
                    dataObjectSelected={dataObjectSelected}
                />
            ) : null}

            {dataObjectSelected.administrativeobjectType ? (
                <ParentObjectEditComponent
                    name={dataObjectSelected.parentAdministrativeobjectName}
                    guid={dataObjectSelected.parentAdministrativeobjectGuid}
                    flatList={weSubFlatList}
                    setValue={setAdministrativeobjectParentValue}
                    value={administrativeobjectParentValue}
                    dataObjectSelected={dataObjectSelected}
                />
            ) : null}

            {dataObjectSelected.realestateobjectType ? (
                <ListItem>
                    <InputLabel className={classes.InputLabel}>Instanztyp</InputLabel>
                    <Select
                        className={classes.selectbox}
                        value={options.filter(option => option.value === instanceTypeId)}
                        onChange={(option) => onChangeInstanceType(option)}
                        options={options}
                    />
                </ListItem>
            ) : null}

            {dataObjectSelected.realestateobjectType ? (
                <ListItem>
                    <InputLabel className={classes.InputLabel}>Nutzungsart</InputLabel>
                    <Select
                        className={classes.selectbox}
                        value={useTypeOptions.filter(option => option.value === useTypeId)}
                        onChange={(option) => onChangeUseType(option)}
                        options={useTypeOptions}
                    />
                </ListItem>
            ) : null}

            <ListItem>
                <InputLabel className={classes.InputLabel}>deaktiviert</InputLabel>
                <ListItemText>{dataObjectSelected.deactivated ? 'ja' : 'nein'}</ListItemText>
            </ListItem>

            <ListItem>
                <InputLabel className={classes.InputLabel}>geändert am</InputLabel>
                <ListItemText>{new Date(dataObjectSelected.last_changed).toLocaleString()}</ListItemText>
            </ListItem>

            {attributeList && attributeList.map((attr) => (
                <ListItem key={attr.guid}>
                    <InputLabel className={classes.InputLabel}>{attr.label}</InputLabel>
                    {attr.type?.toLowerCase() === 'number' || attr.type?.toLowerCase() === 'real' || attr.type?.toLowerCase() === 'integer' ? (
                        <MyTextInput
                            margin="dense"
                            name={"attr_" + attr.guid}
                            type="number"
                            fullWidth
                        />
                    ) : null}
                    {attr.type?.toLowerCase() === 'date' ? (
                        <MyTextInput
                            margin="dense"
                            name={"attr_" + attr.guid}
                            type="date"
                            fullWidth
                        />
                    ) : null}
                    {attr.type?.toLowerCase() === 'boolean' ? (
                        <MyCheckbox name={"attr_" + attr.guid} />
                    ) : null}
                    {!(attr.type?.toLowerCase() === 'number' || attr.type?.toLowerCase() === 'real' || attr.type?.toLowerCase() === 'integer' || attr.type?.toLowerCase() === 'boolean' || attr.type?.toLowerCase() === 'date') ? (
                        <MyTextInput
                            margin="dense"
                            name={"attr_" + attr.guid}
                            type="text"
                            fullWidth
                        />
                    ) : null}
                </ListItem>
            ))}
        </List>
    );
}

export default DataObjectFormItems;
